"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicWorkflow = void 0;
var react_1 = __importDefault(require("react"));
var workflow_1 = require("../../providers/workflow");
var base_1 = require("./base");
function BasicWorkflow(props) {
    var currentStep = props.currentStep, title = props.title, backTooltipText = props.backTooltipText, onBack = props.onBack, children = props.children;
    return (react_1.default.createElement(workflow_1.WorkflowProvider, { currentStep: currentStep },
        react_1.default.createElement(base_1.BaseWorkflowLayout, { title: title, backTooltipText: backTooltipText, onBack: onBack }, children)));
}
exports.BasicWorkflow = BasicWorkflow;
